import apiClient from './apiClient';

/** @returns {Promise<Array<{ company: string, contacts: Array }>>} */
export async function listReferralPanelContacts() {
  const { data } = await apiClient.get('admin/referral-panel/contacts');
  return Array.isArray(data) ? data : [];
}

/**
 * @param {{
 *   firstName: string,
 *   lastName: string,
 *   englishName?: string|null,
 *   company: string,
 *   email: string,
 *   phone: string,
 *   status: 'ACTIVE'|'INACTIVE',
 *   notes?: string|null,
 * }} body
 */
export async function createReferralPanelContact(body) {
  const { data } = await apiClient.post('admin/referral-panel/contacts', body);
  return data;
}

/**
 * @param {number|string} id
 * @param {Parameters<typeof createReferralPanelContact>[0]} body
 */
export async function updateReferralPanelContact(id, body) {
  const { data } = await apiClient.put(`admin/referral-panel/contacts/${id}`, body);
  return data;
}

/** @param {number|string} id */
export async function deleteReferralPanelContact(id) {
  await apiClient.delete(`admin/referral-panel/contacts/${id}`);
}
